const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  device: state => state.app.device,

  userId: state => state.user.id,
  token: state => state.user.token,
  name: state => state.user.name,
  prenom: state => state.user.prenom,
  roles: state => state.user.roles,
  permissions: state => state.user.permissions,
  // Côté de l'utilisateur, calculé par le serveur (UserResource.scope).
  // À préférer partout à une recherche du rôle « extranet client » dans `roles`.
  isExtranet: state => state.user.scope === 'extranet',

  permission_routes: state => state.permission.routes,
  addRoutes: state => state.permission.addRoutes,

  notifications_unread: state => state.notifications.unreadCount,
};

export default getters;
